import { createContext, useContext } from "react";
import { CommandBus, commandBus } from "../commands/CommandBus";
import { ShortcutManager } from "../shortcuts/ShortcutManager";
import { getDesktopEnv, DesktopEnv } from "../desktopEnv";

export interface DesktopKeyboardContextValue {
  desktop: DesktopEnv;
  commandBus: CommandBus;
  shortcuts: ShortcutManager | null;
}

export const DesktopKeyboardContext = createContext<DesktopKeyboardContextValue>({
  desktop: getDesktopEnv(),
  commandBus,
  shortcuts: null,
});

export function useDesktopKeyboardContext() {
  return useContext(DesktopKeyboardContext);
}
